import * as React from 'react';

import { Box, Text } from '@opendoor/bricks/core';

const InfoCard: React.FC<{ text: string }> = ({ text }) => (
  <Box backgroundColor="neutrals10" mt={4} p={5} borderRadius="roundedSquare" color="neutrals100">
    <Text as="span" fontSize="s0">
      {text}
    </Text>
  </Box>
);

export default InfoCard;
